import "twin.macro";

import { TextComponentStyle } from "@glide/component-utils";
import { isEmptyOrUndefinedish } from "@glide/support";
import * as React from "react";

import { Text } from "../../components/text/text";

interface WireCollectionEmptyStateProps {
    readonly message: string | null | undefined;
}

export const WireCollectionEmptyState: React.VFC<WireCollectionEmptyStateProps> = ({ message }) => {
    if (isEmptyOrUndefinedish(message)) return null;
    return (
        <div
            data-testid="collection-empty-state"
            tw="flex justify-center items-center text-center py-12 px-4">
            <Text tw="text-text-contextual-xpale" variant={TextComponentStyle.regular}>
                {message}
            </Text>
        </div>
    );
};
